import { css as o, styled as i } from "styled-components";
import { ZIndex as r, MediaQuery as l } from "../../../../styles/variables.js";
import { Theme as e } from "../../../../styles/themes/index.js";
import { Colors as a } from "../../../../styles/colors/index.js";
var d = /* @__PURE__ */ ((t) => (t.LEFT = "--left", t.TOP = "--top", t.TRANSLATE_X = "--translate-x", t))(d || {});
const s = o`
  top: unset;
  left: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  border-radius: 24px 24px 0 0;
  transform: translate(0, 0);
`, h = o`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0;
  height: 100%;
  width: 100%;
`, c = o`
  top: 0;
  left: 0;
  border-radius: 0;
  height: 100%;
  width: 85%;
  transform: translate(0, 0);
`, x = o`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  height: auto;
  width: 248px;
`, m = i.div`
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  width: 248px;

  z-index: ${r.HEADER_CONTAINER - 1};
  left: var(${"--left"});
  top: var(${"--top"});
  transform: translateX(var(${"--translate-x"}));
  border: 1px solid rgb(${e.colors.Golf});
  background: rgb(${e.colors.Juliet});
  position: ${({ $fixed: t }) => t ? "fixed" : "absolute"};
  padding: 16px;

  overflow: hidden;
  height: auto;
  max-height: none;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgb(${a.Silver});
  }

  scrollbar-width: thin;
  scrollbar-color: #f6f6f6 #888;

  @media ${l.SCREEN_SM} {
    ${s};
    overflow: auto;
    position: fixed;
    z-index: ${r.MODAL_CONTAINER};
  }
`;
export {
  m as Container,
  d as ContainerVars,
  c as dropdownListMobileAsideStyle,
  x as dropdownListMobileCenterStyle,
  h as dropdownListMobileFullPageStyle,
  s as dropdownListMobileOpenBottomStyle
};
